module.exports = __webpack_public_path__ + "img/threedots.198f3fef.svg";